module.exports = __webpack_public_path__ + "static/media/service-image-3.d5a83b20.jpg";